import AddIcon from '@mui/icons-material/Add';
import DeleteButton from '../../components/DeleteButton';
import SearchIcon from '@mui/icons-material/Search';
import { Box, Button, Grid, IconButton, InputAdornment, TextField, Toolbar } from '@mui/material';
import * as React from 'react';
import { useHistory } from 'react-router-dom';

import { ContextStore } from '../../store/contextStore';
import { debounce } from '../../utils';

const WaiverListToolbar = (props) => {
    const createBt = React.useRef(null);
    const deleteBt = React.useRef(null);
    const searchQueryRef = React.useRef(null);
    const history = useHistory();
    const { hasPerm } = React.useContext(ContextStore);
    const hasWritePerm = hasPerm('waiver', 'write');
    const hasDeletePerm = hasPerm('waiver', 'delete');
    const btSize = props.isSmallScreen ? 'medium' : 'small';

    const onCreateNewWaiverBtClick = (ev) => {
        history.push(`/waivers/new`);
    };

    const handleSearchQueryChange = (ev) => {
        debouncedSearchQueryChangeHandler.cancel();
        doSearch(searchQueryRef.current?.value);
    };

    const onDeleteWaiverBtClick = (ev) => {
        props.onDeleteWaiver && props.onDeleteWaiver(props.selectedIds);
    };

    const debouncedSearchQueryChangeHandler = debounce(handleSearchQueryChange, 300);

    const doSearch = (query) => props.onQueryChange && props.onQueryChange(query);

    return (
        <Toolbar disableGutters={true}>
            <Grid container direction="row" justifyContent="space-between" alignItems="center">
                <Grid item xs={12} sm={4} container spacing={2} alignItems={'center'}>
                    <Grid item xs={9} sm={12}>
                        <TextField
                            variant="filled"
                            label="Search"
                            size="small"
                            onChange={debouncedSearchQueryChangeHandler}
                            inputRef={searchQueryRef}
                            defaultValue={props.query}
                            fullWidth
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton aria-label="do search" onClick={handleSearchQueryChange}>
                                            <SearchIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                    {props.isSmallScreen && hasWritePerm && (
                        <Grid item xs={3} container justifyContent={'flex-end'}>
                            <Button
                                ref={createBt}
                                onClick={onCreateNewWaiverBtClick}
                                variant="contained"
                                color="primary"
                                size="medium"
                                sx={{
                                    padding: '6px',
                                    minWidth: '42px',
                                    width: '42px',
                                    height: '42px',
                                }}
                            >
                                <AddIcon />
                            </Button>
                        </Grid>
                    )}
                </Grid>
                <Grid item>
                    {props.selectedIds?.length > 0 && !props.isSmallScreen ? (
                        <Box mr={2}>
                            <DeleteButton ref={deleteBt} allowed={hasDeletePerm} size={btSize} onClick={onDeleteWaiverBtClick}>
                                Delete {props.selectedIds.length > 1 ? 'waivers' : 'waiver'}
                            </DeleteButton>
                        </Box>
                    ) : null}
                    {!hasWritePerm || props.isSmallScreen || props.selectedIds?.length > 0 ? null : (
                        <Box direction="row-reverse">
                            <Button ref={createBt} color="primary" variant="contained" size={btSize} onClick={onCreateNewWaiverBtClick}>
                                <AddIcon />
                                &nbsp;{!props.isSmallScreen ? 'New waiver' : null}
                            </Button>
                        </Box>
                    )}
                </Grid>
            </Grid>
        </Toolbar>
    );
};

export default WaiverListToolbar; 